import { Component, ViewEncapsulation, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Menu } from '@grapecity/wijmo.input';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1201Model, LabelInfo } from './kymw1201.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessDialogMultiMessageServiceSub } from '../../../commons/kymw00/pless-dialog-multi-message-service-sub';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { GetCatalogInfo } from './api-services/get-catalog-info-service';
import { GetFeatureCodeList } from './api-services/get-feature-code-list-service';
import { GetPublishPlanGoodsCategoryListInfo } from './api-services/get-publish-plan-goods-category-list-info-service';
import { GetOrderNumQuotaList } from './api-services/get-order-num-quota-list.service';
import { RegistCycleInfoResponce, RegistCycleInfo as RegistCycleInfoService } from './api-services/regist-cycle-info-service';
import { SaveCycleInfo as SaveCycleInfoService } from './api-services/save-cycle-info-service';
import { SaveCycleInfo, CycleInfoList } from './vo/save-cycle-info.model';
import { RegistCycleInfo, RegistCycleInfoList } from './vo/regist-cycle-info.model';
import { PublishPlanGoodsCategory } from './vo/publish-plan-goods-category-list-info.model';
import { VMediumDutiesFormTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-duties-form-type-combo-box/vmedium-duties-form-type-combo-box.component';
import { KYMW4801Component } from '../../kymw48/kymw4801/kymw4801.component';
import { CrossCodeGet } from '../../kymw48/kymw4801/vo/cross-code-get.model';
import { KYMW4802Component } from '../../kymw48/kymw4802/kymw4802.component';
import { KYMW4802InputModel } from '../../kymw48/kymw4802/vo/kymw4802-input.model';
import { KYMW4802OutputModel } from '../../kymw48/kymw4802/vo/kymw4802-output.model';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { OutputPublishPlanGoodsCategoryListInfo } from './api-services/output-publish-plan-goods-category-list-info.service';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { GetFolioService } from './api-services/get-folio-service';
import { GetBuyerCodeForAgentService } from './api-services/get-buyer-code-for-agent.service';
import { DeleteCyclePlanGoodsCrossService } from './api-services/delete-cycle-plan-goods-cross.service';

import type { ICellTemplateContext } from '@grapecity/wijmo.grid';
import { GetMessagesService } from '../../../shared/get-messages.service';
import { GetMultiMessagesService } from '../../../shared/get-multi-messages.service';
import * as wjInput from '@grapecity/wijmo.input';
import { hasClass, hidePopup, showPopup } from '@grapecity/wijmo';
import { RegistUserColumnWidthSettingsService } from '../../../commons/kymw02/api-services/regist-user-column-width-settings.service';
import { GetUserColumnWidthSettingsService } from '../../../commons/kymw02/api-services/get-user-column-width-settings.service';
import { KYMW0800Component } from '../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { CanDeactivateType } from '../../../shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';
/**
 * 企画回別商品一覧を管理するクラス
 *
 * @export KYMW1201Component
 * @class KYMW1201Component
 */
@Component({
  selector: 'app-kymw1201',
  templateUrl: 'kymw1201.component.html',
  styleUrls: ['kymw1201.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1201Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumDutiesFormTypeComboBoxComponent;
  @ViewChild('dtg_PlanGoodsList', { static: true }) dtg_PlanGoodsList: FlexGrid;
  @ViewChild('fltr_PlanGoodsList', { static: false }) fltr_PlanGoodsList: FlexGridFilter;
  private contextMenu: Menu;

  public model: KYMW1201Model = new KYMW1201Model();

  // ログインユーザーがバイヤーか
  public isbuyer = false;
  // ログインユーザーが取引先か
  public issupplier = false;
  // ログインユーザーがフルコンか
  public isFullControl = this.getFuncPermission('KYMW1200') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;

  // 編集済みフラグ
  private isEdited = false;

  // ダウンロードボタンから保存メソッドが呼び出されたかを判断するフラグ
  public isOutput = false;

  // 列ピッカーの作成
  public columnPicker;

  // フィルタ有無フラグ
  private activeFilter;

  /**
   * Creates an instance of KYMW1201Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1201Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    private getCatalogInfoService: GetCatalogInfo,
    private getFeatureCodeListService: GetFeatureCodeList,
    private getPublishPlanGoodsCategoryListInfoService: GetPublishPlanGoodsCategoryListInfo,
    private getOrderNumQuotaListService: GetOrderNumQuotaList,
    private registCycleInfoService: RegistCycleInfoService,
    private saveCycleInfoService: SaveCycleInfoService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: PlessDialogServiceSub,
    private dialogMMService: PlessDialogMultiMessageServiceSub,
    private getCodeListService: GetCodeListService,
    private outputPublishPlanGoodsCategoryListInfoService: OutputPublishPlanGoodsCategoryListInfo,
    private fileDownloadService: FileDownloadService,
    private getFolioService: GetFolioService,
    private getBuyerCodeForAgentService: GetBuyerCodeForAgentService,
    private deleteCyclePlanGoodsCrossService: DeleteCyclePlanGoodsCrossService,
    private getMessagesServiceSub: GetMessagesService,
    private getMultiMessagesServiceSub: GetMultiMessagesService,
    private registUserColumnWidthSettingsService: RegistUserColumnWidthSettingsService,
    private getUserColumnWidthSettingsService: GetUserColumnWidthSettingsService,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW1201Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1201';

    // ユーザ区分判定
    if (this.kymw00Model.kymw1001Model.isBuyer()) {
      this.isbuyer = true;
    } else {
      // バイヤーでない場合はバイヤー代行者であればバイヤーと同じ扱いとする
      this.getBuyerCodeForAgentService.execute((data) => {
        this.isbuyer = data?.length > 0;
      });
    }

    this.issupplier = this.kymw00Model.kymw1001Model.isSupplier();

    // 取引先コード取得
    this.model.supplierCode = this.kymw00Model.kymw1001Model.loginUserInfo.SupplierCode;

    this.route.queryParams.subscribe((params) => {
      this.model.orderCode = params['orderCode'];
      this.model.mediumType = params['mediumType'];
      this.model.buyerCode = params['buyerCode'];
    });

    if (PlessViewUtilsSub.isEmpty(this.model.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return;
    }

    // コンボボックス 選択肢取得
    // EDLP
    this.getCodeListService.execute("ct289", "", this.model, "edlpList", () => {
      // EDLP 選択肢の作成
      for (const e of this.model.edlpList) {
        this.model.edlpLabelList.push(new LabelInfo(e.CodeValue, e.CodeValue + ':' + e.CodeName));
      }
      // 価格パターン
      this.getCodeListService.execute(
        "ct355",
        "",
        this.model,
        "pricePatternList",
        () => {
           // 価格パターン 選択肢の作成
          this.setPricePatternLabel();
          // 登場区分
          this.getCodeListService.execute(
            "ct363",
            "",
            this.model,
            "appearDivList",
            () => {
              // 登場区分 選択肢の作成
              for (const e of this.model.appearDivList) {
                this.model.appearDivLabelList.push(new LabelInfo(e.CodeValue, e.CodeValue + ':' + e.CodeName));
              }
              // コマプロモーション
              this.getCodeListService.execute(
                "ctp318",
                "",
                this.model,
                "komaPromotionList",
                () => {
                  // コマプロモーション 選択肢の作成
                  for (const e of this.model.komaPromotionList) {
                    this.model.komaPromotionLabelList.push(new LabelInfo(e.CodeValue, e.CodeValue + ':' + e.CodeName));
                  }
                  // プロモーションマーク
                  this.getCodeListService.execute(
                    "ctp319",
                    "",
                    this.model,
                    "promotionMarkList",
                    () => {
                      // プロモーションマーク 選択肢の作成
                      for (const e of this.model.promotionMarkList) {
                        this.model.promotionMarkLabelList.push(new LabelInfo(e.CodeValue, e.CodeValue + ':' + e.CodeName));
                      }
                      // 価格プロモーション
                      this.getCodeListService.execute(
                        "ctp396",
                        "",
                        this.model,
                        "pricePromotionList",
                        () => {
                          // コマプロモーション 選択肢の作成
                          for (const e of this.model.pricePromotionList) {
                            this.model.pricePromotionLabelList.push(new LabelInfo(e.CodeValue, e.CodeValue + ':' + e.CodeName));
                          }
                        }
                      );
                    }
                  );
                }
              );
            }
          );
        }
      );
    });

    this.getCatalogInfoService.execute(this.model, this.model.orderCode);
    this.getFeatureCodeListService.execute(this.model);
    this.getOrderNumQuotaListService.execute(this.model, this.model.orderCode, this.model.mediumType, '0', () => {
      this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, false, () => {
        this.updateBudgetRatioTable();
        this.initFolio();
        this.updateOrderNumQuotaCode();
      });
    });
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW1201Component
   */
  public ngAfterViewInit(): void {
    this.setContextMenu();
    this.initGrid();

    // 表示列設定用のパラメータ
    this.columnPicker = new wjInput.MultiSelect('#columnPicker', {
      itemsSource: this.dtg_PlanGoodsList.columns,
      checkedMemberPath: 'visible',
      displayMemberPath: 'header',
      showSelectAllCheckbox: true,
      placeholder: '表示列設定',
      headerFormat: '表示列設定',
    });
    document.addEventListener('mousedown', (e) => {
      if (hasClass(<Element>e.target, 'column-picker')) {
        let host = this.columnPicker.hostElement;
        if (!host.offsetHeight) {
          showPopup(host, this.columnPicker, false, true, false);
          this.columnPicker.focus();
        } else {
          hidePopup(host, true, true);
          this.dtg_PlanGoodsList.focus();
        }
        e.preventDefault();
      }
    });

    // 表示ボタン押下で表の幅を適用
    const vo = {
      userId: this.sharedModel.kymw1001Model.loginUserInfo.UserID,
      gridId: '1201'
    }
    this.getUserColumnWidthSettingsService.execute(vo, (data) => {
      this.setColumnWidthSettings(data?.ColumnInfo);
    })
  }

  /**
   * コンテキストメニュー初期化
   *
   * @memberof KYMW1201Component
   */
  private setContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: 'クロス候補確認', cmd: 'confirm', enabled: true },
        { caption: 'クロス設定登録', cmd: 'register', enabled: true },
        { caption: 'クロス設定解除', cmd: 'cancel', enabled: true },
        { caption: '実績履歴画面を開く', cmd: 'openResult', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'confirm':
            this.confirmClickHandler();
            break;
          case 'register':
            this.registerClickHandler();
            break;
          case 'cancel':
            this.cancelClickHandler();
            break;
          case 'openResult':
            this.openResult();
            break;
        }
      }
    });
    this.dtg_PlanGoodsList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.contextMenuSelectHandler(e);
        // メニュー表示
        this.contextMenu.show(e);
      }
      if (this.contextMenu) DataGridUtil.showContextMenu(this.dtg_PlanGoodsList, this.contextMenu, e);
    });
  }

  /**
   * コンテキストメニュー活性制御
   *
   * @memberof KYMW1201Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * コンテキストメニュー 選択
   *
   * @memberof KYMW1201Component
   */
  private contextMenuSelectHandler(e: any): void {
    const ht = this.fltr_PlanGoodsList.grid.hitTest(e.pageX, e.pageY);
    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = true;
    // 選択行 ※フィルタした表のデータに対してコンテキストメニューを開くためfltr_PlanGoodsListを使用
    const item = this.fltr_PlanGoodsList.grid.collectionView.items[this.fltr_PlanGoodsList.grid.selection.row];
    // 以下の条件に該当する場合は、コンテキストメニューを非活性
    // 表示している企画回がサイクル確定済の場合
    // または 選択している行がW媒体設定である場合
    // または グリッドのセル外または選択行がない場合
    // または フルコンではない場合
    // ※実績履歴は活性とする
    if (
      ht.cellType !== CellType.Cell ||
      PlessViewUtilsSub.isEmptyArray(this.dtg_PlanGoodsList.selectedRows) ||
      this.model.publishPlanGoodsCategoryListInfo.confirmFlg === "1" ||
      this.model.catalogInfo.catalogFixFlg === "1" ||
      item.wCarryingFlg ||
      !this.isFullControl
    ) {
      contextMenuEnabledMode = false;
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string;  cmd: string;}) => {
        if (item.cmd !== 'openResult') {
          item.enabled = contextMenuEnabledMode;
        }
      });
    } else {
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    }
  }

  /**
   * グリッド初期化
   *
   * @memberof KYMW1201Component
   */
  private initGrid() {
    // グリッドのフィルター設定
    this.fltr_PlanGoodsList.defaultFilterType = FilterType.Both;
    this.fltr_PlanGoodsList.showSortButtons = false;
    this.fltr_PlanGoodsList.filterColumns = [
      'orderCode', 'catalogId', 'className', 'middleClassName', 'smallClassName',
      'goodsName', 'goodsStandardName', 'pcode', 'itemCode', 'janCode', 'largeClassName',
      'payeeClientKanji', 'ordrClientKanji', 'applyTermEnd', 'specialFeature',
      'folio', 'edlp', 'rememberGoods', 'goodsMemo', 'buyerComment', 'coopFlg142', 'coopFlg163',
      'coopFlg185', 'coopFlg240', 'coopFlg210', 'coopFlg302', 'coopFlg515', 'coopFlg451',
      'pricePattern', 'pricePromotion', 'appearDiv', 'bargainMarkFlg', 'komaPromotion',
      'promotionMark', 'orderNumQuotaCode', 'mediumWPublishFlg', 'pCodeOfCross',
      'crossDecisionFlg', 'wCrossFlg', 'thisTimeSupplyPrice', 'thisTimeCostPrice',
      'planNumAiPrediction', 'planNum', 'piValue', 'supplyBudget', 'gpValue', 'gprValue',
    ];

    // チェックボックスのセルクリックでチェックボックスON/OFF可能とする
    this.dtg_PlanGoodsList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_PlanGoodsList.hitTest(e);
      if (0 <= ht.row && (!ht.target.className.includes('wj-header') && !ht.target.className.includes('wj-glyph-filter') && !ht.target.className.includes('ng-valid'))) {
        if (ht.col === 20) document.getElementById(`coopFlg142_${ht.row}`).click();
        if (ht.col === 21) document.getElementById(`coopFlg163_${ht.row}`).click();
        if (ht.col === 22) document.getElementById(`coopFlg185_${ht.row}`).click();
        if (ht.col === 23) document.getElementById(`coopFlg240_${ht.row}`).click();
        if (ht.col === 24) document.getElementById(`coopFlg210_${ht.row}`).click();
        if (ht.col === 25) document.getElementById(`coopFlg302_${ht.row}`).click();
        if (ht.col === 26) document.getElementById(`coopFlg515_${ht.row}`).click();
        if (ht.col === 27) document.getElementById(`coopFlg451_${ht.row}`).click();
        if (ht.col === 31) document.getElementById(`bargainMarkFlg_${ht.row}`).click();
        if (ht.col === 35) document.getElementById(`mediumWPublishFlg_${ht.row}`).click();
        if (ht.col === 37) document.getElementById(`crossDecisionFlg_${ht.row}`).click();
      }
    });

    // フィルタ 設定
    if (this.fltr_PlanGoodsList) {
      this.fltr_PlanGoodsList.filterChanged.addHandler(
        (f: FlexGridFilter) => {
          // フィルタ設定されているかどうかをチェック
          this.activeFilter = f.grid.columns.find(
            _ => f.getColumnFilter(_).isActive
          );
          setTimeout(() => {
            // フィルタ変更で予算比表の計画数（フィルタ）を更新
            this.updateBudgetRatioTableFilteredItem();
          });
        }
      );
    }
  }

  /**
   * ノンブル初期表示
   *
   * @memberof KYMW1201Component
   */
  public initFolio() {
    for (const e of this.model.publishPlanGoodsCategoryInfo) {
      if (this.isbuyer) {
        if (PlessViewUtilsSub.isEmpty(e.specialFeature)) {
          this.model.folioDisabled.push(false)
          e.folio = '';
        } else {
          this.model.folioDisabled.push(true)
        }
      } else {
        this.model.folioDisabled.push(true)
        e.folio = '';
      }
    }
  }

  /**
   * 特集コード 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public featureCode_CHANGEHandler(cell: ICellTemplateContext): void {
    this.isEdited = true;
    if (cell.item.specialFeature === 'blankVal') cell.item.specialFeature = '';
    // 空欄を選択された場合、W・媒体内のチェックを外し、ノンブルを活性状態にし、空に設定する。
    if (PlessViewUtilsSub.isEmpty(cell.item.specialFeature)) {
      cell.item.mediumWPublishFlg = false;
      this.model.folioDisabled[cell.row.index] = false;
      cell.item.folio = '';
    } else {
      // 空欄以外が選択された場合、ノンブルを非活性状態にし、特集コードに紐づくページ情報管理のノンブルを表示する。
      // ノンブル取得VO
      const vo = {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
        FeatureCode: cell.item.specialFeature,
        CoopFlg142: cell.item.coopFlg142 ? '1': '0',
        CoopFlg163: cell.item.coopFlg163 ? '1': '0',
        CoopFlg185: cell.item.coopFlg185 ? '1': '0',
        CoopFlg240: cell.item.coopFlg240 ? '1': '0',
        CoopFlg210: cell.item.coopFlg210 ? '1': '0',
        CoopFlg302: cell.item.coopFlg302 ? '1': '0',
        CoopFlg515: cell.item.coopFlg515 ? '1': '0',
        CoopFlg451: cell.item.coopFlg451 ? '1': '0',
      };
      // ノンブル取得API
      this.getFolioService.execute(vo, data => {
        // ノンブルを非活性状態にする
        this.model.folioDisabled[cell.row.index] = true;
        // 取得したノンブルを格納
        cell.item.folio = data.Folio;
      });
    }
  }

  /**
   * EDLP 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public edlp_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.edlp === 'blankVal') cell.item.edlp = '';
  }

  /**
   * 価格パターン 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public pricePattern_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.pricePattern === 'blankVal') cell.item.pricePattern = '';
    if (this.model.mediumType !== '018') {
      // 媒体が「018:IT先着順」以外のときに価格プロモーションを変更する
      this.setPricePromotion(cell);
    }
    // 今回供給価格と仕入価格を価格パターンの値によって設定
    this.setSupplyPriceAndCostPrice(cell.item);
  }

  /**
   * 価格プロモーション 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public pricePromotion_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.pricePromotion === 'blankVal') cell.item.pricePromotion = '';
  }

  /**
   * 登場区分 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public appearDiv_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.appearDiv === 'blankVal') cell.item.appearDiv = '';
  }

  /**
   * コマプロモーション 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public komaPromotion_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.komaPromotion === 'blankVal') cell.item.komaPromotion = '';
  }

  /**
   * プロモーションマーク 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public promotionMark_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.promotionMark === 'blankVal') cell.item.promotionMark = '';
  }
  
  /**
   * 注文コード割当 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public orderNumQuotaCode_CHANGEHandler(cell: any): void {
    this.isEdited = true;
    if (cell.item.orderNumQuotaCode === 'blankVal') cell.item.orderNumQuotaCode = '';
  }

  /**
   * ノンブル 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public folio_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * バイヤーコメント 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public buyerComment_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * 取扱生協 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public coopFlg_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * お買い得期間 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public bargainMarkFlg_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * W・媒体内 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public mediumWPublishFlg_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * クロス設定確定 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public crossDecisionFlg_CHANGEHandler(): void {
    this.isEdited = true;
  }

  /**
   * 今回供給価 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public thisTimeSupplyPrice_CHANGEHandler(item: any): void {
    this.isEdited = true;
    item.supplyBudget = PublishPlanGoodsCategory.getSupplyBudget(item.thisTimeSupplyPrice, item.planNum, item.planNumAiPrediction);
    item.gpValue = PublishPlanGoodsCategory.getGPValue(item.supplyBudget, item.planNum, item.thisTimeCostPrice, item.bundlePrice, item.planNumAiPrediction);
    item.gprValue = PublishPlanGoodsCategory.getGPRValue(item.gpValue, item.supplyBudget);
    this.updateBudgetRatioTable();
  }

  /**
   * 今回仕入価 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public thisTimeCostPrice_CHANGEHandler(item: any): void {
    this.isEdited = true;
    item.gpValue = PublishPlanGoodsCategory.getGPValue(item.supplyBudget, item.planNum, item.thisTimeCostPrice, item.bundlePrice, item.planNumAiPrediction);
    item.gprValue = PublishPlanGoodsCategory.getGPRValue(item.gpValue, item.supplyBudget);
    this.updateBudgetRatioTable();
  }

  /**
   * 計画数(修正後) 変更イベントハンドラ
   *
   * @memberof KYMW1201Component
   */
  public planNum_CHANGEHandler(item: any): void {
    this.isEdited = true;
    item.piValue = PublishPlanGoodsCategory.getPIValue(item.planNum, this.model.publishPlanGoodsCategoryListInfo.useNumPeople, item.planNumAiPrediction);
    item.supplyBudget = PublishPlanGoodsCategory.getSupplyBudget(item.thisTimeSupplyPrice, item.planNum, item.planNumAiPrediction);
    item.gpValue = PublishPlanGoodsCategory.getGPValue(item.supplyBudget, item.planNum, item.thisTimeCostPrice, item.bundlePrice, item.planNumAiPrediction);
    item.gprValue = PublishPlanGoodsCategory.getGPRValue(item.gpValue, item.supplyBudget);
    this.updateBudgetRatioTable();
  }

  /**
   * 価格パターン変更時に価格プロモーションの値を変更する
   *
   * @memberof KYMW1201Component
   */
  public setPricePromotion(cell: any): void {
    const pricePattern = cell.item.pricePattern;
    // 特集コードが固定特集「特だ値ひろば」 かつ ノンブルが「表紙」 の場合
    if (cell.item.specialFeature === "00100" && cell.item.folio === "1") {
      // （空白）
      cell.item.pricePromotion = "";
    } else {
      switch (pricePattern) {
        // ○：通常
        case "0":
          // （空白）
          cell.item.pricePromotion = "";
          break;
        // △：特1
        case "1":
          // 006:今週のお買い得
          cell.item.pricePromotion = "006";
          break;
        // □：特2
        case "2":
          // ノンブルが「表紙」の場合
          if (cell.item.folio === "1") {
            // （空白）
            cell.item.pricePromotion = "";
            // 特集コードが得だ値
          } else if (cell.item.specialFeature === "001A1") {
            // （空白）
            cell.item.pricePromotion = "";
          } else {
            // 005:スーパープライス
            cell.item.pricePromotion = "005";
          }
          break;
        // ☆：特3
        case "3":
          // 050:最安値
          cell.item.pricePromotion = "050";
          break;
        default:
          break;
      }
    }
  }

  /**
   * 予算比表を更新する
   *
   * @memberof KYMW1201Component
   */
  private updateBudgetRatioTable() {
    // 計画数（フィルタ）
    this.updateBudgetRatioTableFilteredItem();

    // 計画数（全体）
    let plannedValuePlannedValue = 0;
    let plannedValueSupplyAmount = 0;
    let plannedValueGP = 0;
    let plannedValueItemNum = 0;
    for (const e of this.model.publishPlanGoodsCategoryInfo) {
      plannedValueItemNum++;
      if (e.planNum !== '') {
        plannedValuePlannedValue = plannedValuePlannedValue + Number(e.planNum);
      } else if (e.planNumAiPrediction !== '') {
        plannedValuePlannedValue = plannedValuePlannedValue + Number(e.planNumAiPrediction);
      }
      if (e.supplyBudget !== '') plannedValueSupplyAmount = plannedValueSupplyAmount + Number(e.supplyBudget);
      if (e.gpValue !== '') plannedValueGP = plannedValueGP + Number(e.gpValue);
    }
    this.model.plannedValuePlannedValue = plannedValuePlannedValue;
    this.model.plannedValueSupplyAmount = plannedValueSupplyAmount;
    this.model.plannedValueGP = plannedValueGP;
    this.model.plannedValueItemNum = plannedValueItemNum;
    if (plannedValueGP === 0 || plannedValueSupplyAmount === 0) {
      this.model.plannedValueGPR = 0;
    } else {
      this.model.plannedValueGPR = (plannedValueGP / plannedValueSupplyAmount) * 100;
    }

    // 予算比
    if (plannedValuePlannedValue === 0 || Number(this.model.publishPlanGoodsCategoryListInfo.planResult) === 0) {
      this.model.budgetRatioPlannedValue = 0;
    } else {
      this.model.budgetRatioPlannedValue = (plannedValuePlannedValue / Number(this.model.publishPlanGoodsCategoryListInfo.planResult)) * 100;
    }
    if (plannedValueSupplyAmount === 0 || Number(this.model.publishPlanGoodsCategoryListInfo.supply) === 0) {
      this.model.budgetRatioSupplyAmount = 0;
    } else {
      this.model.budgetRatioSupplyAmount = (plannedValueSupplyAmount / Number(this.model.publishPlanGoodsCategoryListInfo.supply)) * 100;
    }
    if (plannedValueGP === 0 || Number(this.model.publishPlanGoodsCategoryListInfo.gp) === 0) {
      this.model.budgetRatioGP = 0;
    } else {
      this.model.budgetRatioGP = (plannedValueGP / Number(this.model.publishPlanGoodsCategoryListInfo.gp)) * 100;
    }
    this.model.plannedValueGPR = Math.round(this.model.plannedValueGPR * 100) / 100;
    this.model.publishPlanGoodsCategoryListInfo.budgetValueGPR = String(Math.round(Number(this.model.publishPlanGoodsCategoryListInfo.budgetValueGPR) * 100) / 100);
    this.model.budgetRatioGPR = this.model.plannedValueGPR - Number(this.model.publishPlanGoodsCategoryListInfo.budgetValueGPR);
  }

  /**
   * 予算比表の計画数（フィルタ）を更新する
   *
   * @memberof KYMW1201Component
   */
  private updateBudgetRatioTableFilteredItem() {
    // 計画数（フィルタ）
    let filteredPlannedValuePlannedValue = 0;
    let filteredPlannedValueSupplyAmount = 0;
    let filteredPlannedValueGP = 0;
    let filteredPlannedValueItemNum = 0;
    
    let targetList = [];
    // for文で回すリストを設定
    if (this.activeFilter) {
      // フィルタが設定されている場合はフィルタ後のリスト
      targetList = this.fltr_PlanGoodsList.grid.collectionView.items
    } else {
      // フィルタが設定されていない場合は全体のリスト
      targetList = this.model.publishPlanGoodsCategoryInfo;
    }
    for (const e of targetList) {
      filteredPlannedValueItemNum++;
      if (e.planNum !== '') {
        filteredPlannedValuePlannedValue = filteredPlannedValuePlannedValue + Number(e.planNum);
      } else if (e.planNumAiPrediction !== '') {
        filteredPlannedValuePlannedValue = filteredPlannedValuePlannedValue + Number(e.planNumAiPrediction);
      }
      if (e.supplyBudget !== '') filteredPlannedValueSupplyAmount = filteredPlannedValueSupplyAmount + Number(e.supplyBudget);
      if (e.gpValue !== '') filteredPlannedValueGP = filteredPlannedValueGP + Number(e.gpValue);
    }
    this.model.filteredPlannedValuePlannedValue = filteredPlannedValuePlannedValue;
    this.model.filteredPlannedValueSupplyAmount = filteredPlannedValueSupplyAmount;
    this.model.filteredPlannedValueGP = filteredPlannedValueGP;
    this.model.filteredPlannedValueItemNum = filteredPlannedValueItemNum;
    if (filteredPlannedValueGP === 0 || filteredPlannedValueSupplyAmount === 0) {
      this.model.filteredPlannedValueGPR = 0;
    } else {
      this.model.filteredPlannedValueGPR = (filteredPlannedValueGP / filteredPlannedValueSupplyAmount) * 100;
    }
    this.model.filteredPlannedValueGPR = Math.round(this.model.filteredPlannedValueGPR * 100) / 100;
  }

  /**
   * 注文コード割当を更新する
   *
   * @memberof KYMW1201Component
   */
  private updateOrderNumQuotaCode() {

    if (this.model.publishPlanGoodsCategoryListInfo.confirmFlg !== '1' || this.model.catalogInfo.catalogFixFlg === "0") {
      for (const e of this.model.publishPlanGoodsCategoryListInfo.publishPlanGoodsCategoryList) {
        // 注文コード割当が未設定 の場合は予め注文コード割当コードを設定する
        if (e.orderNumQuotaCode.trim() === '' && !e.wCarryingFlg) {
          // 媒体が「ハピデリ」の場合
          if (this.model.mediumType === '001') {
            e.orderNumQuotaCode = '001';
            // 媒体が「ぐるめぐり」の場合
          } else if (this.model.mediumType === '003') {
            e.orderNumQuotaCode = '401';
          } else {
            // その他の場合、注文コード割当コードが最小値のものを設定
            e.orderNumQuotaCode = this.model.orderNumQuotaList[0].orderNumQuotaCode;
          }
        }
        // W掲載設定状態 の場合はクロス商品の文字列は表示しない
        if (e.wCarryingFlg) {
          e.pCodeOfCross = '';
        }
      }
    }  
  }

  /**
   * 選択肢を作成する
   *
   * @memberof KYMW1201Component
   */
  public setPricePatternLabel() {

    for (const e of this.model.pricePatternList) {
      let mark = '';
      
      switch (e.CodeValue) {
        case '0':
          mark = '○';
          break;    
        case '1':
          mark = '△';
          break;   
        case '2':
          mark = '□';
          break;   
        case '3':
          mark = '☆';
          break;   
        default:
          mark = ' ';
          break;
      }
      this.model.pricePatternLabelList.push(new LabelInfo(e.CodeValue, mark + ':' + e.CodeName));
    }
  }

  /**
   * コンテキストメニュー クロス候補確認 クリック
   *
   * @memberof KYMW1201Component
   */
  private confirmClickHandler() {
    // フィルタした表のデータに対してコンテキストメニューを開くためfltr_PlanGoodsListを使用
    const item = this.fltr_PlanGoodsList.grid.collectionView.items[this.fltr_PlanGoodsList.grid.selection.row];

    // クロス商品設定画面
    const vo: KYMW4802InputModel = {
      mediumType: this.cmb_MediumType.selectedMediumType,
      mediumName: this.cmb_MediumType.selectedMediumName,
      catalogId: item.catalogId,
      orderCode: item.orderCode,
      pcode: item.pcode,
      guideGoodsName: item.goodsName,
      guidsStandardName: item.goodsStandardName,
    }

    const componentRef = this.dialogService.openModal(KYMW4802Component);
    const instance = componentRef.componentInstance as KYMW4802Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW4802Parameter = () => {
      this.isEdited = true;
    };
    instance.closeFunction = () => {
      componentRef.close();
      // クロスコード、クロス商品取得のためAPI実行
      this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, true, () => {
        this.dtg_PlanGoodsList.refresh();
      });
    };
  }

  /**
   * コンテキストメニュー クロス設定登録 クリック
   *
   * @memberof KYMW1201Component
   */
  private registerClickHandler() {
    // フィルタした表のデータに対してコンテキストメニューを開くためfltr_PlanGoodsListを使用
    const item = this.fltr_PlanGoodsList.grid.collectionView.items[this.fltr_PlanGoodsList.grid.selection.row];

    // クロス設定登録画面
    const vo: CrossCodeGet = {
      orderCode: item.orderCode,
      mediumType: this.cmb_MediumType.selectedMediumType,
      pCode: item.pcode,
    }

    const componentRef = this.dialogService.openModal(KYMW4801Component);
    const instance = componentRef.componentInstance as KYMW4801Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW4801Parameter = () => {
      this.isEdited = true;
    };
    instance.closeFunction = () => {
      componentRef.close();
      // クロスコード、クロス商品取得のためAPI実行
      this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, true, () => {
        this.dtg_PlanGoodsList.refresh();
      });
    };
  }

  /**
   * コンテキストメニュー クロス設定解除 クリック
   *
   * @memberof KYMW1201Component
   */
  private cancelClickHandler() {
    // フィルタした表のデータに対してコンテキストメニューを開くためfltr_PlanGoodsListを使用
    const item = this.fltr_PlanGoodsList.grid.collectionView.items[this.fltr_PlanGoodsList.grid.selection.row];
    this.deleteCyclePlanGoodsCrossService.execute(this.model, item,
      () => {  // API成功時処理
        this.isEdited = true;
        // クロスコード、クロス商品取得のためAPI実行
        this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, true, () => {
          this.dtg_PlanGoodsList.refresh();
        });
      },
      () => { // API失敗時処理
        // 設定に失敗しました。
        this.dialogService.openAlertGetMessage('E0540');
      }
    );
  }

  /**
   * コンテキストメニュー 実績履歴画面を開く
   *
   * @memberof KYMW1200Component
   */
  public openResult() {
    if (!(this.dtg_PlanGoodsList.selectedItems[0] instanceof PublishPlanGoodsCategory)) return;
    const selItem = this.dtg_PlanGoodsList.selectedItems[0];
    // 実績履歴画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0800Component);
    const instance = componentRef.componentInstance as KYMW0800Component;
    instance.parent = this;
    const input = new KYMW0800InputModel();
    input.funcID = 'KYMW1201';
    input.pCodeList = [
      {
        PCode: PlessViewUtilsSub.escapeXML(selItem.pcode),
        GuideGoodsName: PlessViewUtilsSub.escapeXML(selItem.goodsName),
        GuideStandardName: PlessViewUtilsSub.escapeXML(selItem.goodsStandardName),
      },
    ];
    instance.setInterfaceParam(input);

    instance.closeFunction = ()=> {
      componentRef.close();
    }
  }

  /**
   * 保存ボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public updateCycleInfo_CLICKHandler(): void {
    let isInvalid = false;
    const cycleInfoList: CycleInfoList[] = [];
    for (const e of this.model.publishPlanGoodsCategoryInfo) {
      if (this.validSaveCycle(e) !== '') {
        isInvalid = true;
      }
      cycleInfoList.push(this.newSaveCycleInfoList(e));
    }

    if (isInvalid) {
      this.dialogService.openAlertGetMessage('Q0501', null, (e) => {
        if (e === PlessAlert.Yes) {
          this.model.saveCycleInfo = new SaveCycleInfo(cycleInfoList, '0');
          this.saveCycleInfoService.execute(this.model, () => {
            this.dialogService.openAlertGetMessage('I0521', null, (e) => {
              this.isEdited = false;
              if(e === PlessAlert.Yes && this.isOutput) {
                // ダウンロードボタン押下時は保存後にファイル出力を行う
                this.output();
                this.isOutput = false;
              }
            });
          });
        }
      });
    } else {
      this.model.saveCycleInfo = new SaveCycleInfo(cycleInfoList, '0');
      this.saveCycleInfoService.execute(this.model, () => {
        this.dialogService.openAlertGetMessage('I0521', null, (e) => {
          this.isEdited = false;
          if(e === PlessAlert.Yes && this.isOutput) {
            // ダウンロードボタン押下時は保存後にファイル出力を行う
            this.output();
            this.isOutput = false;
          }
        });
      });
    }
  }

  /**
   * サイクル確定ボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public registCycleInfo_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0187', null, _c => {
      if (_c === PlessAlert.Yes) {
        const saveCycleInfoList: CycleInfoList[] = [];
        const registCycleInfoList: RegistCycleInfoList[] = [];
        for (const e of this.model.publishPlanGoodsCategoryInfo) {
          const invalidName = this.validSaveCycle(e);
          if (invalidName !== '') {
            this.dialogService.openAlertGetMessage('E0110', [invalidName]);
            return;
          }

          saveCycleInfoList.push(this.newSaveCycleInfoList(e));
          registCycleInfoList.push(this.newRegistCycleInfoList(e))
          
          // W媒体設定 True は サイクル情報登録APIリクエストしない
          if(e.wCarryingFlg) continue;
        }
        this.model.saveCycleInfo = new SaveCycleInfo(saveCycleInfoList, '1');
        this.saveCycleInfoService.execute(this.model, () => {
          this.isEdited = false;
          this.model.registCycleInfo = new RegistCycleInfo(
            this.model.orderCode, this.model.mediumType, this.model.buyerCode, registCycleInfoList
          );
          const reloadList = () => {
            this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, false, () => {
              this.dialogService.openAlertGetMessage('I0522');
            });
          };
          this.registCycleInfoService.execute(this.model, (data: RegistCycleInfoResponce) => {
            // 00:正常終了、01:警告発生
            if (data.CheckResult === "01" && !PlessViewUtilsSub.isEmptyArray(data.WarningList)) {
              let replaceMessage = '';
              // 受け取ったエラーの数だけ、エラーダイアログに表示する文言を増やす
              for (const warning of data.WarningList) {
                // PCodeListをカンマ区切りに整形
                const pcodeList = this.formatAlertPCodeList(warning.PCodeList);
                // messages.xmlのデータ取得サービス呼び出し
                this.getMessagesServiceSub.execute(warning.MessageID, (message: any) => {
                  // メッセージ内容にコロンを付けてPコードを結合。前の行から改行をする。
                  const responseMessage = message.Description[0];
                  replaceMessage += '\n' + responseMessage + '：' + pcodeList;
                });
              }
              this.dialogService.openAlertGetMessage(data.MessageID, [replaceMessage], (close: any)=>{
                if (close === PlessAlert.Yes) {
                  reloadList();
                }
              });
            } else if (data.CheckResult === "01" && !PlessViewUtilsSub.isEmptyArray(data.CheckErrorList) ) {
              // エラーリストのチェック
              if (!PlessViewUtilsSub.isEmptyArray(data.CheckErrorList)) {                 // エラーありの場合
                let arrList: Array<any> = new Array<any>();
                const replaceArray: Array<Array<string>> = new Array<Array<string>>();
                const msgIdList: Array<any> = new Array<any>();
                arrList = data.CheckErrorList;

                // エラーメッセージ表示
                for (const errData of arrList) {                                          // エラーリスト要素数分ループ
                  const replacetemp = new Array<string>();
                  replacetemp.push(errData.Parameter1);
                  replacetemp.push(errData.Parameter2);
                  replacetemp.push(errData.Parameter3);
                  replacetemp.push(errData.Parameter4);
                  replacetemp.push(errData.Parameter5);
                  replaceArray.push(replacetemp);
                  msgIdList.push(errData.MessageID);
                }
                // エラーメッセージ表示
                this.dialogMMService.openAlertGetMessage(msgIdList, replaceArray, false,() => { });
              }
            } else {
              reloadList();
            }
          });
        });
      }
    });
  }

  /**
   * サイクル情報保存のバリデーション
   *
   * @memberof KYMW1201Component
   */
  private validSaveCycle(e: PublishPlanGoodsCategory): string {
    if (e.orderNumQuotaCode === 'blankVal' || PlessViewUtilsSub.isEmpty(e.orderNumQuotaCode)) return '注文コード割当';
    if (e.pricePattern === 'blankVal' || PlessViewUtilsSub.isEmpty(e.pricePattern)) return '価格パターン';
    if (!e.thisTimeSupplyPrice) return '今回供給価';
    if (!e.thisTimeCostPrice) return '今回仕入価';
    return '';
  }

  /**
   * サイクル情報保存のパラメータ作成
   *
   * @memberof KYMW1201Component
   */
  private newSaveCycleInfoList(e: PublishPlanGoodsCategory): CycleInfoList {
    return new CycleInfoList(
      e.orderCode, this.model.mediumType, e.pcode, e.itemCode, e.specialFeature,
      e.folio, e.edlp, e.rememberGoods, e.buyerComment, e.coopEnabledFlg142,
      e.coopEnabledFlg163, e.coopEnabledFlg185, e.coopEnabledFlg240, e.coopEnabledFlg210,
      e.coopEnabledFlg302, e.coopEnabledFlg515, e.coopEnabledFlg451,
      e.pricePattern, e.pricePromotion, e.bargainMarkFlg ? '1': '0', e.komaPromotion,
      e.promotionMark, e.appearDiv, e.orderNumQuotaCode, e.mediumWPublishFlg ? '1': '0',
      e.crossDecisionFlg ? '1': '0', e.wCrossFlg ? '1': '0', e.thisTimeSupplyPrice,
      e.thisTimeCostPrice, e.planNum
    )
  }

  /**
   * サイクル情報登録のパラメータ作成
   *
   * @memberof KYMW1201Component
   */
  private newRegistCycleInfoList(e: PublishPlanGoodsCategory): RegistCycleInfoList {
    return new RegistCycleInfoList(
      e.pcode, e.itemCode, e.specialFeature, e.orderNumQuotaCode, 
      e.mediumWPublishFlg ? '1': '0', e.crossDecisionFlg ? '1': '0', e.crossCode,
      e.pricePromotion, e.komaPromotion, e.promotionMark
    )
  }

  /**
   * サイクル設定画面に戻るボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public eventBack_CLICKHandler(): void {
    if (this.isEdited && this.isFullControl) {
      this.dialogService.openAlertGetMessage('Q0186', null, _c => {
        if (_c === PlessAlert.Yes) {
          this.onBack();
          // 保持している変更フラグを戻しておく（canDeactivateのため）
          this.isEdited = false;
        }
      });
    } else {
      this.onBack();
    }
  }

  /**
   * サイクル設定画面に戻るボタン押下時共通処理
   *
   * @memberof KYMW1201Component
   */
  private onBack(): void {
    this.router.navigate(['/kymw/1200']);
  }

  /**
   * ページング戻るボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public onPrevClick(): void {
    if (this.model.prevDisabled) {
      return;
    }
    if (this.isEdited && this.isFullControl) {
      this.dialogService.openAlertGetMessage('Q0186', null, _c => {
        if (_c === PlessAlert.Yes) {
          this.onPaging(this.model.catalogInfo.previousOrderCode);
        }
      });
    } else {
      this.onPaging(this.model.catalogInfo.previousOrderCode);
    }
  }

  /**
   * ページング次へボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public onNextClick(): void {
    if (this.model.nextDisabled) {
      return;
    }
    if (this.isEdited && this.isFullControl) {
      this.dialogService.openAlertGetMessage(
        'Q0186', null, _c => {
          if (_c === PlessAlert.Yes) {
            this.onPaging(this.model.catalogInfo.nextOrderCode);
          }
        }
      );
    } else {
      this.onPaging(this.model.catalogInfo.nextOrderCode);
    }
  }

  /**
   * ページング時共通処理
   *
   * @memberof KYMW1201Component
   */
  public onPaging(orderCode: string): void {
    this.model.initFlg = '0';
    this.getCatalogInfoService.execute(this.model, orderCode, () => {
      this.model.orderCode = orderCode;
      this.getPublishPlanGoodsCategoryListInfoService.execute(this.model, false, () => {
        this.isEdited = false;
        this.updateBudgetRatioTable();
        this.updateOrderNumQuotaCode();
      });
    });
  }

  /**
   * 企画回の商品情報ダウンロードボタン押下イベント処理
   *
   * @memberof KYMW1201Component
   */
  public outputPublishPlanGoodsCategoryListInfo_CLICKHandler(): void {
    if (this.isEdited) {
      this.dialogService.openAlertGetMessage('Q0171', null, _c => {
        if (_c === PlessAlert.Yes) {
          // ダウンロードフラグをtrueにして保存メソッドを実行
          this.isOutput = true;
          this.updateCycleInfo_CLICKHandler();
        } else {
          // 変更破棄処理
          this.model.revertPublishPlanGoodsCategoryInfoChanges();
          this.output();
        }
      });
    } else {
      this.output();
    }
  }

  /** 
   * 企画回別商品一覧表出力メソッド実行
   * 
   * @memberof KYMW1201Component
   */
  private output(): void {
    const vo = {
      OrderCode: this.model.orderCode,
      MediumType: this.model.mediumType,
      BuyerCode: this.model.buyerCode,
      SupplierCode: this.model.supplierCode
    }
    this.outputPublishPlanGoodsCategoryListInfoService.execute(this.model, vo, (data:any) => {
      this.dialogService.openAlertGetMessage('Q0163', null,  _c => {
        if (_c === PlessAlert.Yes) {
          // ファイル名の設定
          const fileName = '企画回別商品一覧_' + this.model.orderCode + '_' + this.model.mediumType + '_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xlsx';
          this.fileDownloadService.execute(data.FileName, fileName);
        }
      });
    });
  }

  /**
   * 画面表示用にコードと名称を:繋ぎの文字列に変換する
   * 
   * @memberof KYMW1201Component
   */
  public toDisplayCodeAndName(code: string, name: string): string {
    return PlessViewUtilsSub.toDisplayCodeAndName(code, name);
  }

  /**
   * 今回供給価格と仕入価を価格パターンの値によって設定
   * 
   * @memberof KYMW1201Component
   * @param item 
   */
  public setSupplyPriceAndCostPrice(item: any): void {
    // 今回供給価格と仕入価格を反映
    if (item.pricePattern == "0") {
      // 通常の場合は通常価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceStandard;
      item.thisTimeCostPrice = item.costPriceStandard;
    } else if (item.pricePattern == "1") {
      // 特1の場合は特1価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial1;
      item.thisTimeCostPrice = item.costPriceSpecial1;
    } else if (item.pricePattern == "2") {
      // 特2の場合は特2価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial2;
      item.thisTimeCostPrice = item.costPriceSpecial2;
    } else {
      // その他の場合はブランクを格納
      item.thisTimeSupplyPrice = null;
      item.thisTimeCostPrice = null;
    }

    // 今回供給価 変更イベントハンドラで再計算
    this.thisTimeSupplyPrice_CHANGEHandler(item);
  }

  /**
   * アラートダイアログに表示するPコードリストのフォーマット
   * @param pCodeList 
   * @returns 
   */
  public formatAlertPCodeList(pCodeList: string[]): string {
    let result: string[] = [];
    pCodeList.forEach((item, i) => {
      result.push(String(item));

      // 最後の要素は何も付けない
      if (i === pCodeList.length - 1) return;

      // 改行条件
      if (i === 2) {
        result.push(",\n"); // 最初の3個のあと
      } else if (i > 2 && (i - 2) % 5 === 0) {
        result.push(",\n"); // その後は5個ごと
      } else {
        result.push(","); // それ以外はカンマ
      }
    });

    return result.join("");
  }

  /** グリッドのカラム幅・表示カラム保存 */
  public saveColumnWidthSettings(): void {
    // 列幅設定登録
    // リクエスト用VO作成
    const vo = {
      userId: this.sharedModel.kymw1001Model.loginUserInfo.UserID,
      gridId: '1201',
    };
    this.registUserColumnWidthSettingsService.execute(vo, this.dtg_PlanGoodsList, null);
  }

  /** グリッドのカラム幅をセット */
  public setColumnWidthSettings(columnInfo: any): void {
    if (!PlessViewUtilsSub.isEmptyArray(columnInfo)) {
      // カラム名と幅の数値をそれぞれパラメータとするリスト
      const columnList = Object.keys(columnInfo).map(key => ({
        header: key,
        width: columnInfo[key].width,
        displayFlg: columnInfo[key].displayFlg
      }));
      // 表のカラムごとに幅の数値を設定する
      this.dtg_PlanGoodsList.columns.map(column => {
        // 改行しているヘッダーは改行を外した文字列で判定
        const headerName = column.header?.replace("\n", "");
        const targetData = columnList.find(w => w.header === headerName);
        // 幅の数値
        const targetWidth = targetData?.width;
        // 表示フラグ
        const targetDisplayFlg = targetData?.displayFlg;
        if (targetWidth) {
          // 幅の数値があればwidthに設定
          column.width = Number(targetWidth);
        }
        if (targetDisplayFlg) {
          const flg = targetDisplayFlg === '1';
          // 表示フラグがあればvisibleに設定
          column.visible = flg;
          // チェック状態反映
          // ※itemsSourceに含まれている列かチェック
          const targetHeader = this.columnPicker.itemsSource.find(item => item.header === column.header);
          if (targetHeader) {
            targetHeader.visible = flg;
          }
        }
      })
      // チェック状態を更新（非表示カラムを除外）
      this.columnPicker.checkedItems = this.columnPicker.itemsSource.filter(item => item.visible);
      this.columnPicker.onCheckedItemsChanged();
    }
  }
    
  /**
   * ディアクティベート処理
   */
  public canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    // 「閲覧モードではない」かつ「内容が変更されている」時は確認メッセージを表示
    if (this.isEdited && this.isFullControl) {
      this.dialogService.openAlertGetMessage(
        'Q0107', ['企画回別商品一覧'],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            result.next(true);
          } else {
            result.next(false);
          }
        });
      return result;
    } else {
      return true;
    }
  }
}
